import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useIndustries } from "@/hooks/useIndustries";

const CLEAR = "__clear__";

// Shared industry picker. Reads the canonical list from useIndustries() — never takes an options prop.
export function IndustrySelect({ value, onChange, placeholder = "Select industry", disabled, allowClear }) {
  const items = useIndustries();
  return (
    <Select value={value || ""} onValueChange={(v) => onChange(v === CLEAR ? null : v)} disabled={disabled}>
      <SelectTrigger data-testid="industry-select"><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {allowClear && <SelectItem value={CLEAR}>— None —</SelectItem>}
        {items.map((i) => <SelectItem key={i.id} value={i.id} data-testid={`industry-option-${i.key}`}>{i.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
